import { render } from "./index.vue?vue&type=template&id=749c6c30&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-749c6c30"

export default script